export enum StripePaymentMode {
  VIEW = 'view',
  ADD = 'add',
  UPDATE = 'update',
}

export enum StripeOnTokenMethod {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum cardStatusValues {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  DECLINED = 'Declined',
  PENDING = 'Pending',
}

export const addressInitialState = {
  address: '',
  city: '',
  state: '',
  zip: '',
  cardHolderName: '',
  cardNickName: '',
};

export const addressErrorInitialState = {
  address: null,
  city: null,
  state: null,
  zip: null,
  cardHolderName: null,
  cardNickName: null,
};

export const usStatesChoices: any = [
  { title: 'Alaska', label: 'Alaska', unique_key: 'AK', value: 'Alaska' },
  { title: 'Alabama', label: 'Alabama', unique_key: 'AL', value: 'Alabama' },
  {
    title: 'Arkansas',
    label: 'Arkansas',
    unique_key: 'AR',
    value: 'Arkansas',
  },
  { title: 'Arizona', label: 'Arizona', unique_key: 'AZ', value: 'Arizona' },
  {
    title: 'California',
    label: 'California',
    unique_key: 'CA',
    value: 'California',
  },
  {
    title: 'Colorado',
    label: 'Colorado',
    unique_key: 'CO',
    value: 'Colorado',
  },
  {
    title: 'Connecticut',
    label: 'Connecticut',
    unique_key: 'CT',
    value: 'Connecticut',
  },
  {
    title: 'District of Columbia',
    label: 'District of Columbia',
    unique_key: 'DC',
    value: 'District of Columbia',
  },
  {
    title: 'Delaware',
    label: 'Delaware',
    unique_key: 'DE',
    value: 'Delaware',
  },
  { title: 'Florida', label: 'Florida', unique_key: 'FL', value: 'Florida' },
  { title: 'Georgia', label: 'Georgia', unique_key: 'GA', value: 'Georgia' },
  { title: 'Hawaii', label: 'Hawaii', unique_key: 'HI', value: 'Hawaii' },
  { title: 'Iowa', label: 'Iowa', unique_key: 'IA', value: 'Iowa' },
  { title: 'Idaho', label: 'Idaho', unique_key: 'ID', value: 'Idaho' },
  {
    title: 'Illinois',
    label: 'Illinois',
    unique_key: 'IL',
    value: 'Illinois',
  },
  { title: 'Indiana', label: 'Indiana', unique_key: 'IN', value: 'Indiana' },
  { title: 'Kansas', label: 'Kansas', unique_key: 'KS', value: 'Kansas' },
  {
    title: 'Kentucky',
    label: 'Kentucky',
    unique_key: 'KY',
    value: 'Kentucky',
  },
  {
    title: 'Louisiana',
    label: 'Louisiana',
    unique_key: 'LA',
    value: 'Louisiana',
  },
  {
    title: 'Massachusetts',
    label: 'Massachusetts',
    unique_key: 'MA',
    value: 'Massachusetts',
  },
  {
    title: 'Maryland',
    label: 'Maryland',
    unique_key: 'MD',
    value: 'Maryland',
  },
  { title: 'Maine', label: 'Maine', unique_key: 'ME', value: 'Maine' },
  {
    title: 'Michigan',
    label: 'Michigan',
    unique_key: 'MI',
    value: 'Michigan',
  },
  {
    title: 'Marshall Islands',
    label: 'Marshall Islands',
    unique_key: 'MH',
    value: 'Marshall Islands',
  },
  {
    title: 'Minnesota',
    label: 'Minnesota',
    unique_key: 'MN',
    value: 'Minnesota',
  },
  {
    title: 'Missouri',
    label: 'Missouri',
    unique_key: 'MO',
    value: 'Missouri',
  },
  {
    title: 'Mississippi',
    label: 'Mississippi',
    unique_key: 'MS',
    value: 'Mississippi',
  },
  { title: 'Montana', label: 'Montana', unique_key: 'MT', value: 'Montana' },
  {
    title: 'North Carolina',
    label: 'North Carolina',
    unique_key: 'NC',
    value: 'North Carolina',
  },
  {
    title: 'North Dakota',
    label: 'North Dakota',
    unique_key: 'ND',
    value: 'North Dakota',
  },
  {
    title: 'Nebraska',
    label: 'Nebraska',
    unique_key: 'NE',
    value: 'Nebraska',
  },
  {
    title: 'New Hampshire',
    label: 'New Hampshire',
    unique_key: 'NH',
    value: 'New Hampshire',
  },
  {
    title: 'New Jersey',
    label: 'New Jersey',
    unique_key: 'NJ',
    value: 'New Jersey',
  },
  {
    title: 'New Mexico',
    label: 'New Mexico',
    unique_key: 'NM',
    value: 'New Mexico',
  },
  { title: 'Nevada', label: 'Nevada', unique_key: 'NV', value: 'Nevada' },
  {
    title: 'New York',
    label: 'New York',
    unique_key: 'NY',
    value: 'New York',
  },
  { title: 'Ohio', label: 'Ohio', unique_key: 'OH', value: 'Ohio' },
  {
    title: 'Oklahoma',
    label: 'Oklahoma',
    unique_key: 'OK',
    value: 'Oklahoma',
  },
  { title: 'Oregon', label: 'Oregon', unique_key: 'OR', value: 'Oregon' },
  {
    title: 'Pennsylvania',
    label: 'Pennsylvania',
    unique_key: 'PA',
    value: 'Pennsylvania',
  },
  {
    title: 'Rhode Island',
    label: 'Rhode Island',
    unique_key: 'RI',
    value: 'Rhode Island',
  },
  {
    title: 'South Carolina',
    label: 'South Carolina',
    unique_key: 'SC',
    value: 'South Carolina',
  },
  {
    title: 'South Dakota',
    label: 'South Dakota',
    unique_key: 'SD',
    value: 'South Dakota',
  },
  {
    title: 'Tennessee',
    label: 'Tennessee',
    unique_key: 'TN',
    value: 'Tennessee',
  },
  { title: 'Texas', label: 'Texas', unique_key: 'TX', value: 'Texas' },
  { title: 'Utah', label: 'Utah', unique_key: 'UT', value: 'Utah' },
  {
    title: 'Virginia',
    label: 'Virginia',
    unique_key: 'VA',
    value: 'Virginia',
  },
  { title: 'Vermont', label: 'Vermont', unique_key: 'VT', value: 'Vermont' },
  {
    title: 'Washington',
    label: 'Washington',
    unique_key: 'WA',
    value: 'Washington',
  },
  {
    title: 'Wisconsin',
    label: 'Wisconsin',
    unique_key: 'WI',
    value: 'Wisconsin',
  },
  {
    title: 'West Virginia',
    label: 'West Virginia',
    unique_key: 'WV',
    value: 'West Virginia',
  },
  { title: 'Wyoming', label: 'Wyoming', unique_key: 'WY', value: 'Wyoming' },
];
